import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Header, Title} from './sheet';
import {Button} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";

const SignupPromptSheet = styled(({className, onClose}) => {

    const history = useHistory();

    const handleSignup = async () => {
        onClose();
        history.replace('/registration');
    }

    const handleLogin = async () => {
        onClose();
        history.replace('/login');
    }

    return (
        <div className={className}>

            <Header>
                <Title>
                    Sign up to continue
                </Title>
            </Header>

            <p>Join our community to post, comment, and vote.</p>

            <Button variant={"grey"} width={"100%"} mt={6} onClick={handleLogin}>Log In</Button>
            <Button variant={"blue"} width={"100%"} mt={2} onClick={handleSignup}>Create an account</Button>

        </div>
    );
})`
p {
  font-size: 17px;
}
`;

export default SignupPromptSheet;
